import { FC } from 'react';
import { SearchInput } from '@new/common/ui/SearchInput/SearchInput';

interface InstructorSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
}

export const InstructorSearch: FC<InstructorSearchProps> = ({
  searchQuery,
  onSearchChange,
  placeholder = 'Search instructors...',
}) => {
  return (
    <SearchInput
      value={searchQuery}
      onChange={onSearchChange}
      placeholder={placeholder}
      className="flex-1"
    />
  );
};
